/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/design-system/use-heading */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */

import React, { useEffect, useMemo, useState, type CSSProperties, type ReactNode } from 'react';

import { cssMap, jsx } from '@compiled/react';

import {
	HERO_TYPOGRAPHY_WORDMARK_VIEWBOX,
	type LetterIntroStyle,
	type ScribbleEaseName,
} from './hero-typography-wordmark-constants';
import { LetterA } from './LetterA';
import { Scribble } from './Scribble';

const HERO_VIEWBOX_WIDTH = HERO_TYPOGRAPHY_WORDMARK_VIEWBOX.width;
const HERO_VIEWBOX_HEIGHT = HERO_TYPOGRAPHY_WORDMARK_VIEWBOX.height;

const STATIC_LETTERS_PATH = [
	'M638.732 338.001v-146h24.999v58.6h39.198v-58.6h24.998v146h-24.998v-64.2h-39.198v64.2zM524.818 338.001v-146h48.598q14.598 0 25.398 5.6 11 5.6 16.999 15.8 6 10 6 23.6 0 13.4-6.2 23.6-6 10.2-16.799 15.8-10.8 5.6-25.398 5.6h-23.599v56zm24.999-78.6h23.599q10.398 0 16.599-6 6.399-6.2 6.399-16.4 0-10.4-6.399-16.4-6.201-6-16.599-6h-23.599zM224.003 160.001l36.798-146h32.198l36.998 146h-25.599l-7.999-35.4h-38.798l-8 35.4zm38.198-55.8h29.598l-8.8-39.2a982 982 0 0 1-3.799-17.6q-1.6-8-2.2-11.6-.6 3.6-2.2 11.6-1.4 7.8-3.8 17.4z',
	'M287.788 338.001v-146h46.197q14.6 0 25.199 5.4 10.799 5.4 16.799 15.2 6 9.6 6 22.8 0 14.4-7.4 25.4-7.2 11-19.599 15.6l28.998 61.6h-27.998l-25.398-58h-17.799v58zm24.999-80h21.198q10.6 0 16.599-5.8t6-16q0-10.4-6-16.2-5.999-6-16.599-6h-21.198zM223.47 340.001q-13.999 0-24.599-5.2-10.398-5.4-16.199-15-5.6-9.8-5.599-23v-63.6q0-13.4 5.599-23 5.8-9.6 16.199-14.8 10.6-5.4 24.599-5.4 14.199 0 24.399 5.4 10.399 5.2 16.199 14.8 5.799 9.6 5.799 23h-25.198q0-10.4-5.6-15.8-5.4-5.4-15.599-5.4t-15.799 5.4-5.6 15.6v63.8q0 10.2 5.6 15.8t15.799 5.6 15.599-5.6q5.6-5.6 5.6-15.8v-14.8H219.87v-21.6h49.997v36.4q0 13.2-5.799 23-5.8 9.6-16.199 15-10.2 5.2-24.399 5.2M805.406 160.001v-146h24.999v59h17.399l27.398-59h27.199l-32.599 70 34.198 76h-27.798l-28.798-64.2h-16.999v64.2zM693.49 160.001v-146h46.198q14.598 0 25.198 5.4 10.8 5.4 16.799 15.2 6 9.6 6 22.8 0 14.4-7.4 25.4-7.2 11-19.599 15.6l28.999 61.6h-27.999l-25.398-58h-17.799v58zm24.999-80h21.199q10.599 0 16.599-5.8 5.999-5.8 5.999-16 0-10.4-5.999-16.2-6-6-16.599-6h-21.199zM473.659 160.001l-14.999-146h21.599l8.799 94q.4 3.4.6 8.4.4 4.8.6 9.8.4 5 .4 8.8.4-3.8.8-8.8t.8-9.8q.6-5 1-8.4l11.999-94h20.999l11.2 94q.6 3.4.999 8.4.6 4.8 1.2 9.8t1 8.8q.2-3.8.4-8.8t.4-9.8q.4-5 .8-8.4l8.6-94h21.398l-15.799 146h-27.598l-10.799-94.4q-.4-3.8-1-8.8-.4-5.2-.8-10.2a421 421 0 0 1-.6-8.8q-.2 3.6-.8 8.8-.4 5-.8 10.2a358 358 0 0 1-.8 8.8l-11.799 94.4zM345.745 160.001v-146h29.598l14.2 46.4q2.2 7 3.599 12.8 1.401 5.8 1.8 8.4.4-2.6 1.8-8.4t3.4-12.8l13.599-46.4h29.598v146h-23.398v-45.4q0-10 .6-21.8t1.4-23.6a851 851 0 0 1 1.8-22.4c.799-7.067 1.466-9.267 1.999-14.6l-19.598 73h-22.799l-20.199-73c.667 5.067 1.333 7.067 2 14a736 736 0 0 1 1.8 22q1 11.6 1.6 23.6t.6 22.8v45.4zM121.315 160.001v-146h87.595v21.8h-62.997v38h55.997v21.6h-55.997v42.8h62.997v21.8zM38.198 160.001v-122.8H0v-23.2h101.594v23.2H63.396v122.8z',
].join(' ');

const LETTER_A_BOX = { x: 393.387, y: 184.501, width: 122, height: 161 } as const;
const SCRIBBLE_BOX = { x: 525, y: 0, width: 195, height: 168 } as const;

const SCRIBBLE_EASE_PRESETS: Record<ScribbleEaseName, [number, number, number, number]> = {
	linear: [0, 0, 1, 1],
	'ease-in': [0.55, 0.055, 0.675, 0.19],
	'ease-out': [0.215, 0.61, 0.355, 1],
	'ease-in-out': [0.645, 0.045, 0.355, 1],
	'back-out': [0.34, 1.56, 0.64, 1],
};

const styles = cssMap({
	root: {
		position: 'relative',
		width: '100%',
		height: '100%',
		margin: 0,
		padding: 0,
		font: 'inherit',
		fontWeight: 'inherit',
		color: 'inherit',
	},
	svgLayer: {
		position: 'absolute',
		inset: 0,
		width: '100%',
		height: '100%',
		fill: 'none',
	},
	decorativeLayer: {
		display: 'block',
		width: '100%',
		height: '100%',
		userSelect: 'none',
	},
	absolute: {
		position: 'absolute',
	},
});

const VISUALLY_HIDDEN_STYLE: CSSProperties = {
	position: 'absolute',
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	whiteSpace: 'nowrap',
	border: 0,
};

function splitLetterSubpaths(combined: string): string[] {
	return combined.match(/M[^M]*/g) ?? [];
}

function mulberry32(seed: number) {
	let state = seed >>> 0 || 1;
	return () => {
		state = (state + 0x6d2b79f5) >>> 0;
		let t = state;
		t = Math.imul(t ^ (t >>> 15), t | 1);
		t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
}

function buildShuffledOrder(count: number, seed: number): number[] {
	const order = Array.from({ length: count }, (_, i) => i);
	const rand = mulberry32(seed);
	for (let i = order.length - 1; i > 0; i--) {
		const j = Math.floor(rand() * (i + 1));
		[order[i], order[j]] = [order[j], order[i]];
	}
	return order;
}

function pct(value: number, total: number) {
	return `${(value / total) * 100}%`;
}

function IntroDelayAfterMount({ delayMs, children }: { delayMs: number; children: ReactNode }) {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		const id = window.setTimeout(() => setMounted(true), delayMs);
		return () => window.clearTimeout(id);
	}, [delayMs]);
	return mounted ? <>{children}</> : null;
}

function IntroDelay({ delayMs, children }: { delayMs: number; children: ReactNode }) {
	if (delayMs <= 0) return <>{children}</>;
	return <IntroDelayAfterMount delayMs={delayMs}>{children}</IntroDelayAfterMount>;
}

function useStaggeredVisibility(delaysMs: readonly number[]): boolean[] {
	const [visible, setVisible] = useState<boolean[]>(() => delaysMs.map((delay) => delay <= 0));

	useEffect(() => {
		const initial = delaysMs.map((delay) => delay <= 0);
		if (initial.every(Boolean)) return;
		setVisible(initial);

		const timers: number[] = [];
		delaysMs.forEach((delay, i) => {
			if (delay <= 0) return;
			const id = window.setTimeout(() => {
				setVisible((prev) => {
					if (prev[i]) return prev;
					const next = prev.slice();
					next[i] = true;
					return next;
				});
			}, delay);
			timers.push(id);
		});

		return () => {
			for (const id of timers) window.clearTimeout(id);
		};
	}, [delaysMs]);

	return visible;
}

function StaticLetters({
	paths,
	delaysMs,
	fill,
	style,
	fadeDurationMs,
	blurStartPx,
	reducedMotion,
}: {
	paths: readonly string[];
	delaysMs: readonly number[];
	fill: string;
	style: LetterIntroStyle;
	fadeDurationMs: number;
	blurStartPx: number;
	reducedMotion: boolean;
}) {
	const visible = useStaggeredVisibility(reducedMotion ? paths.map(() => 0) : delaysMs);
	let transition: string | undefined;
	if (style === 'fade-in') {
		transition = `opacity ${fadeDurationMs}ms ease-out`;
	} else if (style === 'fade-in-blur') {
		transition = `opacity ${fadeDurationMs}ms ease-out, filter ${fadeDurationMs}ms ease-out`;
	}
	return (
		<svg
			viewBox={`0 0 ${HERO_VIEWBOX_WIDTH} ${HERO_VIEWBOX_HEIGHT}`}
			css={styles.svgLayer}
			aria-hidden
		>
			{paths.map((d, i) => {
				const isVisible = reducedMotion || visible[i];
				const filter =
					style === 'fade-in-blur' ? `blur(${isVisible ? 0 : blurStartPx}px)` : undefined;
				return (
					<path
						key={d}
						fill={fill}
						d={d}
						style={{
							opacity: isVisible ? 1 : 0,
							transition: reducedMotion ? undefined : transition,
							filter,
						}}
					/>
				);
			})}
		</svg>
	);
}

export type HeroTypographyWordmarkProps = {
	heroScale: number;
	letterALineWidth: number;
	letterADurationMs: number;
	letterAStartTimeMs: number;
	letterANodePhaseStart: number;
	letterANodePhaseEnd: number;
	letterAShuffleNodes: boolean;
	letterAShuffleSeed: number;
	scribbleDurationMs: number;
	scribbleStartTimeMs: number;
	scribbleEase: ScribbleEaseName;
	scribbleLineWidth?: number;
	scribbleBlurPx?: number;
	letterIntroTotalDurationMs: number;
	letterIntroStartDelayMs: number;
	letterIntroShuffleSeed: number;
	letterIntroStyle: LetterIntroStyle;
	letterIntroFadeDurationMs: number;
	letterIntroBlurStartPx: number;
	accessibleName: string;
	reducedMotion?: boolean;
};

export function HeroTypographyWordmark({
	heroScale,
	letterALineWidth,
	letterADurationMs,
	letterAStartTimeMs,
	letterANodePhaseStart,
	letterANodePhaseEnd,
	letterAShuffleNodes,
	letterAShuffleSeed,
	scribbleDurationMs,
	scribbleStartTimeMs,
	scribbleEase,
	scribbleLineWidth,
	scribbleBlurPx,
	letterIntroTotalDurationMs,
	letterIntroStartDelayMs,
	letterIntroShuffleSeed,
	letterIntroStyle,
	letterIntroFadeDurationMs,
	letterIntroBlurStartPx,
	accessibleName,
	reducedMotion = false,
}: HeroTypographyWordmarkProps): JSX.Element {
	const ease = SCRIBBLE_EASE_PRESETS[scribbleEase] ?? SCRIBBLE_EASE_PRESETS['ease-in'];
	const letterPaths = useMemo(() => splitLetterSubpaths(STATIC_LETTERS_PATH), []);
	const letterDelaysMs = useMemo(() => {
		const count = letterPaths.length;
		if (count === 0) return [];
		const order = buildShuffledOrder(count, letterIntroShuffleSeed);
		return order.map((slot) => {
			const t = count <= 1 ? 0 : slot / (count - 1);
			return letterIntroStartDelayMs + t * letterIntroTotalDurationMs;
		});
	}, [
		letterPaths.length,
		letterIntroShuffleSeed,
		letterIntroTotalDurationMs,
		letterIntroStartDelayMs,
	]);

	return (
		<h1
			css={styles.root}
			style={{
				transform: `scale(${heroScale})`,
				transformOrigin: 'center center',
			}}
		>
			<span style={VISUALLY_HIDDEN_STYLE}>{accessibleName}</span>
			<span aria-hidden="true" css={styles.decorativeLayer}>
				<StaticLetters
					paths={letterPaths}
					delaysMs={letterDelaysMs}
					fill="#f0f1f2"
					style={letterIntroStyle}
					fadeDurationMs={letterIntroFadeDurationMs}
					blurStartPx={letterIntroBlurStartPx}
					reducedMotion={reducedMotion}
				/>
				<div
					css={styles.absolute}
					style={{
						left: pct(LETTER_A_BOX.x, HERO_VIEWBOX_WIDTH),
						top: pct(LETTER_A_BOX.y, HERO_VIEWBOX_HEIGHT),
						width: pct(LETTER_A_BOX.width, HERO_VIEWBOX_WIDTH),
						height: pct(LETTER_A_BOX.height, HERO_VIEWBOX_HEIGHT),
					}}
				>
					<IntroDelay delayMs={reducedMotion ? 0 : letterAStartTimeMs}>
						<LetterA
							strokeColor="#ffffff"
							strokeWidth={letterALineWidth}
							durationMs={letterADurationMs}
							nodePhaseStart={letterANodePhaseStart}
							nodePhaseEnd={letterANodePhaseEnd}
							shuffleNodes={letterAShuffleNodes}
							shuffleSeed={letterAShuffleSeed}
							reducedMotion={reducedMotion}
						/>
					</IntroDelay>
				</div>
				<div
					css={styles.absolute}
					style={{
						left: pct(SCRIBBLE_BOX.x, HERO_VIEWBOX_WIDTH),
						top: pct(SCRIBBLE_BOX.y, HERO_VIEWBOX_HEIGHT),
						width: pct(SCRIBBLE_BOX.width, HERO_VIEWBOX_WIDTH),
						height: pct(SCRIBBLE_BOX.height, HERO_VIEWBOX_HEIGHT),
					}}
				>
					<IntroDelay delayMs={reducedMotion ? 0 : scribbleStartTimeMs}>
						<Scribble
							durationMs={scribbleDurationMs}
							ease={ease}
							color="#FFC716"
							lineWidth={scribbleLineWidth}
							blurPx={scribbleBlurPx}
							reducedMotion={reducedMotion}
						/>
					</IntroDelay>
				</div>
			</span>
		</h1>
	);
}
